import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { enGB, Locale } from 'date-fns/locale';
import { LanguageCode } from '../models/language-code';
import { langCodeToIntlFEData } from '../models/languages-fe-model';

@Injectable({
    providedIn: 'root',
})
export class DatePickerIntlService {
    constructor(
        private readonly adapter: DateAdapter<any>,
        private readonly destroyRef: DestroyRef,
        private readonly translateService: TranslateService
    ) {}

    /**
     * Monitors changes in the selected language and updates DateAdapter locale accordingly. Subscribes
     * to the `onLangChange` event of the translation service to detect changes in the selected language.
     * Upon a language change, it retrieves the corresponding DateFns locale from the `langCodeToIntlFEData` map
     * and updates the DateAdapter locale accordingly.
     */
    monitorLocale(): void {
        this.translateService.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result) => {
                const locale: Locale =
                    langCodeToIntlFEData.get(result.lang as LanguageCode)
                        ?.dateFnsLocale ?? enGB;
                this.adapter.setLocale(locale);
            });
    }
}
